<div class="container">
  <div class="dialog-title">
    <div class="title-text">בחירת קבוצה</div>
  </div>

  <mat-form-field appearance="outline" class="search-field">
    <mat-label>חיפוש קבוצה</mat-label>
    <input matInput (input)="onSearch($event)" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  @if (!loading()) {
    <div class="list-container">
      <mat-selection-list [multiple]="true" (selectionChange)="onSelectionChange($event)">
        @for (group of filteredGroups(); track group) {
          <mat-list-option [value]="group"
            [selected]="isSelected(group)" togglePosition="before">
            <div class="group-row">
              <span class="group-name">{{ group.group_name || group.group_user }}</span>
              <span class="member-count">
                <mat-icon class="member-icon">people</mat-icon>
                {{ (group.member_count ?? 0) | number }}
              </span>
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  } @else {
    <div class="spinner-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  <ng-template #spinner>
    <div class="spinner-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-template>

  <div class="buttons-container">
    <button mat-flat-button (click)="onCancel()">בטל</button>
    <button mat-flat-button color="primary" [disabled]="selectedGroups().length === 0" (click)="onConfirm()">אשר ({{ selectedGroups().length }})</button>
  </div>
</div>
